import { getResellers } from "../services/resellers.service";
import { getOrganizations, getOrganizationTypes } from "../services/organizations.service";
import { getTaskUsersList } from "../services/tasks.service";
import { getTagsList } from "../services/tags.service";

/**
 * Get All list reseller
 */
export const getAllResellerList = async (filters) => {
	const resellers = [];

	const getData = async (page = 1) => {
		// Fetch Api
		return new Promise((resolve) => {
			getResellers({ ...filters, page }, async (res) => {
				resellers.push(...res.data);
				if (res.meta.current_page < res.meta.last_page) {
					await getData(res.meta.current_page + 1);
				}
				resolve();
			});
		});
	};

	await getData();

	return resellers;
};

/**
 * Get all organizations list
 * @param filters
 * @returns {Promise<*[]>}
 */
export const getAllOrganizationsList = async (filters) => {
	const body = {
		...filters,
		per_page: 200,
	};

	const organizations = [];

	const getData = async (page = 1) => {
		// Fetch Api
		return new Promise((resolve) => {
			getOrganizations({ ...body, page }, async (res) => {
				organizations.push(...res.data);
				if (res.meta.current_page < res.meta.last_page) {
					await getData(res.meta.current_page + 1);
				}
				resolve();
			});
		});
	};

	await getData();

	return organizations;
};

/**
 * Get all organization types list
 * @param filters
 * @returns {Promise<*[]>}
 */
export const getAllOrganizationTypesList = async (filters) => {
	const body = {
		...filters,
		per_page: 100,
	};

	const types = [];

	const getData = async (page = 1) => {
		// Fetch Api
		return new Promise((resolve) => {
			getOrganizationTypes({ ...body, page }, async (res) => {
				types.push(...res.data);
				if (res.meta.current_page < res.meta.last_page) {
					await getData(res.meta.current_page + 1);
				}
				resolve();
			});
		});
	};

	await getData();

	return types;
};

/**
 * Get all resellers list
 * @param filters
 * @returns {Promise<*[]>}
 */
export const getAllResellersList = async (filters) => {
	const body = {
		...filters,
		per_page: 100,
	};

	const resellers = [];

	const getData = async (page = 1) => {
		// Fetch Api
		return new Promise((resolve) => {
			getResellers({ ...body, page }, async (res) => {
				resellers.push(...res.data);
				if (res.meta.current_page < res.meta.last_page) {
					await getData(res.meta.current_page + 1);
				}
				resolve();
			});
		});
	};

	await getData();

	return resellers;
};

/**
 * Get all task users list
 * @param filters
 * @returns {Promise<*[]>}
 */
export const getAllTaskUsers = async (filters) => {
	const body = {
		...filters,
		per_page: 100,
	};

	const users = [];

	const getData = async (page = 1) => {
		// Fetch Api
		return new Promise((resolve) => {
			getTaskUsersList({ ...body, page }, async (res) => {
				users.push(...res.data);
				if (res.meta.current_page < res.meta.last_page) {
					await getData(res.meta.current_page + 1);
				}
				resolve();
			});
		});
	};

	await getData();

	return users;
};

/**
 * Get all tags list
 * @param filters
 * @returns {Promise<*[]>}
 */
export const getAllTagsList = async (filters) => {
	const body = {
		...filters,
		per_page: 100,
	};

	const tags = [];

	const getData = async (page = 1) => {
		// Fetch Api
		return new Promise((resolve) => {
			getTagsList({ params: { ...body, page } }, async (res) => {
				tags.push(...res.data);
				if (res.meta.current_page < res.meta.last_page) {
					await getData(res.meta.current_page + 1);
				}
				resolve();
			});
		});
	};

	await getData();

	return tags;
};
